import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputEmail, InputFile, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseList from '../base/base-list.component';
import Model from './personalinfo-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import PersonalinfotypeModel from '../personalinfotype/personalinfotype-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import PersonalinfotypePicklist from '../personalinfotype/personalinfotype-picklist.component';
import RegionPicklist from '../region/region-picklist.component';
import DivisionPicklist from '../division/division-picklist.component';
import UserPicklistPersonalinfo from '../user/user-picklist-personalinfo.component';
import ScheduleChecklist from '../schedule/schedule-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    caption?: string;
    personalinfotypeType?: string;
    datarow?: any;
    save?: boolean;
    onSave?: (data: any) =>void;
    onError?: (data: any) =>void;
    disableView?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
    save: boolean;
}

export default class PersonalinfoCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadAllPersonalinfotype = (data: any) => {
        this.onLoadPersonalinfotype(data?.[0]);
    }

    private onLoadPersonalinfotype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'personalinfotype': data?.id, 'personalinfotypeCaption': data?.name || '', 'personalinfotypeType': data?.type || 'customer'   }  });
    }
    
    private onLoadBirthplace = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'birthplace': data?.id, 'birthplaceCaption': data?.description || ''  }  });
    }
    
    private onLoadDivision = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'division': data?.id, 'divisionCaption': data?.name || ''  }  });
    }
    
    private onLoadSchedule = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'schedule': data || [], 'scheduleCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    } 
    
    private onLoadUser = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'user': data?.id, 'userCaption': data?.name || ''  }  });
    }
    
    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{files: data, ref: Model.endPointMedia, field:'image'}}});
    }

    private onError = (data: any) => {
        if (data) {
            this.setState({errors: data, save: false});
            this.props.onError?.(data)
        }
    }
    
    private onSave = (data: any) => {
        this.setState({save: false});
        this.props.onSave?.(data)
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidUpdate() {
        if (this.props.save && this.props.save !== this.state.save && this.props.datarow.user > 0) 
            this.setState({datarow: { ...this.state.datarow, ...this.props.datarow}, save: true});
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} caption={this.props.disableView? ' ' : this.props.caption} buttonCaption={this.props.disableView? ' ' : ''}
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onError={this.onError} save={this.state.save} onSave={this.onSave} disableAutoBack={this.props.disableView} disableBackButton={this.props.disableView} disableCard={this.props.disableView}>              
                
                {this.props.disableView ?
                <BaseList history={this.props.history} caption=' ' endPointFilter={PersonalinfotypeModel.endPointFilterList(this.props.personalinfotypeType)} model={PersonalinfotypeModel} onLoadAll={this.onLoadAllPersonalinfotype} disableView/>
                
                :
                <>
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist> 
                }            
                <InputPicklist name='personalinfotype' label='Type' value={this.state.datarow.personalinfotype} caption={this.state.datarow.personalinfotypeCaption} error={this.state.errors?.personalinfotype} onChange={this.onChange} >
                    <PersonalinfotypePicklist currentId={this.state.datarow.personalinfotype} type={this.props.personalinfotypeType} onLoad={this.onLoadPersonalinfotype}/>
                </InputPicklist>           
                <Input name='phone' label='Phone' value={this.state.datarow.phone} error={this.state.errors?.phone} onChange={this.onChange} />
                <InputEmail name='email' label='Email' value={this.state.datarow.email} error={this.state.errors?.email} onChange={this.onChange} />
                <InputPicklist name='birthplace' label='Place of Birth' value={this.state.datarow.birthplace} caption={this.state.datarow.birthplaceCaption} error={this.state.errors?.birthplace} onChange={this.onChange} >
                    <RegionPicklist history={this.props.history} caption='Select Place of Birth' currentId={this.state.datarow.birthplace} regionType='city' onLoad={this.onLoadBirthplace}/>
                </InputPicklist>  
                <InputDate name='birthdate' label='Date of Birth' value={this.state.datarow.birthdate} error={this.state.errors?.birthdate} onChange={this.onChange} disableTime/>
                <InputSelect name='gender' label='Gender' value={this.state.datarow.gender} options={Model.optionGender} error={this.state.errors?.gender} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Photo' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                {this.state.datarow.personalinfotypeType === 'employee' &&
                <>
                <InputPicklist name='division' label='Division' value={this.state.datarow.division} caption={this.state.datarow.divisionCaption} error={this.state.errors?.division} clearValue={this.onLoadDivision} onChange={this.onChange} >
                    <DivisionPicklist currentId={this.state.datarow.division} onLoad={this.onLoadDivision}/>
                </InputPicklist>
                <InputPicklist name='schedule' label='Schedule List' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} disableAutoClose clearValue={this.onLoadSchedule} error={this.state.errors?.schedule} onChange={this.onChange} >
                    <ScheduleChecklist history={this.props.history} currentId={this.state.datarow.schedule} onLoad={this.onLoadSchedule} disableBackButton/>
                </InputPicklist>
                </>
                }
                <InputPicklist name='user' label='User' value={this.state.datarow.user} caption={this.state.datarow.userCaption} error={this.state.errors?.user} clearValue={this.onLoadUser} onChange={this.onChange} >
                    <UserPicklistPersonalinfo currentId={this.state.datarow.user} onLoad={this.onLoadUser}/>
                </InputPicklist>
                </>
                }
            </BaseCreate>
        );
    }     
     
}